import '../Sass/App.scss';
import React from 'react';
import { SpectrumItem } from './SpectrumItem';

export function ComplexitySpectrum (props) {

    return (
        <div style={{width: '100%'}}>
            <div className='spectrum-box' style={{fontSize: '1.1em'}}>
                <span style={{float: 'left'}}>
                    <b>SIMPLE</b><br/>
                    <span style={{color: 'white'}}>Straightforward gameplay</span>
                </span>
                <span style={{float: 'right', textAlign: 'right'}}>
                    <b>COMPLEX</b><br/>
                    <span style={{color: 'white'}}>Special cards, multiple mechanics</span>
                    </span>
            </div>
            { props.codebases.map((codebase, index) =>
                <SpectrumItem
                    codebase={codebase}
                    key={codebase.codebase_id || index}
                    selected={String(props.selectedCodebaseId) === String(codebase.codebase_id)}
                    selectCodebase={props.selectCodebase}
                />
            )}
        </div>
    )

}
